import { render, staticRenderFns } from "./AppBase.vue?vue&type=template&id=4c3b767c&"
import script from "./AppBase.vue?vue&type=script&lang=js&"
export * from "./AppBase.vue?vue&type=script&lang=js&"
import style0 from "./AppBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports